import { VhcRecordLogService, VHCRecordPartInput } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateCheckPartsInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordPartInput;
};

export const useSaveCheckPartsMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsChecksParts, CreateCheckPartsInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: CreateCheckPartsInput) =>
      VhcRecordLogService.postVhcRecordsItemsChecksParts(logId, itemId, requestBody),
    options
  );
